module.exports = __webpack_public_path__ + "static/media/icon-facebook.d781ac47.svg";